<section class="pb-lg-4 mb-xl-10">
  @if(isLoading()){
  <ng-container *ngTemplateOutlet="skeletonTable"></ng-container>
  }@else {

  <div class="pb-12">
    <!-- <div
      class="d-flex flex-row justify-content-between align-items-center mb-8"
    >
      <h2 class="fw-bold">คอร์สเรียนทั้งหมด</h2>
    </div> -->

    <!-- A category with nothing in it — or an id that names no category at
         all — used to render header, footer and 739 characters of nothing.
         Say so, and offer the way back. -->
    @if (!tableLoading() && !dataSource?.data?.length) {
    <div class="card">
      <div class="card-body">
        <div class="empty-state" data-testid="category-empty">
          <span class="empty-state__mark">
            <app-keenicon name="book-open" class="fs-2tx"></app-keenicon>
          </span>
          <p class="empty-state__title">{{ "APP.CATEGORY_EMPTY" | translate }}</p>
          <p class="empty-state__body">{{ "APP.CATEGORY_EMPTY_HINT" | translate }}</p>
          <a class="btn btn-primary" routerLink="/courses">{{ "MENU.COURSES" | translate }}</a>
        </div>
      </div>
    </div>
    } @else {
    <div class="min-h-600px">
      <app-course-table-widget [dataColumns]="columns" [dataSource]="dataSource" [isLoading]="tableLoading()"
        (onRowClick)="onRowClick($event)" (tableChange)="onTableChange($event)"></app-course-table-widget>
    </div>
    }
  </div>
  }
</section>


<ng-template #skeletonTable>
  <div class="mb-4">
    <div class="card min-h-500px w-100 px-0">
      <div class="card-body d-flex flex-column justify-content-between p-8">
        <div class="row">
          <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
          <div class="separator my-8"></div>
          <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
          <div class="separator my-8"></div>
          <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #skeletonTableItem>
  <div class="col-12 d-flex flex-column flex-md-row gap-6">
    <div class="skeleton h-150px h-sm-175px h-lg-175px object-fit-cover w-100 w-md-200px mb-4 mb-sm-0"></div>
    <div class="d-flex flex-column justify-content-between flex-fill">
      <div class="mb-4">
        <div class="d-flex flex-row w-100 justify-content-between">
          <div class="d-flex flex-column w-100">
            <div class="skeleton w-100 mw-150px h-30px"></div>
            <div class="skeleton w-100 mw-200px h-25px mt-4"></div>
          </div>
          <div class="d-none d-md-block">
            <ng-container *ngTemplateOutlet="SkeletonStar"></ng-container>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row align-items-center w-100 gap-4">
        <!-- Tutor avatar — now circular in the real content
             (course-table-widget.component.html), so the placeholder shape
             matches instead of resolving into a different one. -->
        <div class="skeleton rounded-circle w-100 mw-30px h-30px"></div>
        <div class="skeleton w-100 mw-125px h-20px"></div>
        <div class="skeleton w-100 mw-80px h-20px"></div>
        <div class="skeleton w-100 mw-80px h-20px"></div>
        <div class="skeleton w-100 mw-80px h-20px"></div>
      </div>
      <div class="d-md-none mt-4">
        <ng-container *ngTemplateOutlet="SkeletonStar"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #SkeletonStar>
  <div class="d-flex flex-row gap-2">
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
  </div>
</ng-template>